import { render, staticRenderFns } from "./MailPreviewDialog.vue?vue&type=template&id=c38b7ce4&scoped=true"
import script from "./MailPreviewDialog.vue?vue&type=script&lang=js"
export * from "./MailPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./MailPreviewDialog.vue?vue&type=style&index=0&id=c38b7ce4&prod&lang=css"
import style1 from "./MailPreviewDialog.vue?vue&type=style&index=1&id=c38b7ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b7ce4",
  null
  
)

export default component.exports